import * as React from 'react';
import PersonnelPage from 'src/components/personnel/pages/PersonnelPage';
import RoutePrivate from 'src/components/router/RoutePrivate';
import VendorsPage from './pages/VendorsPage';
import VouchersPage from './pages/VouchersPage';
import CreditCardsRecPage from './pages/CreditCardsRecPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [
        <RoutePrivate key="accounts-payable" path="/accounts-payable/vendors" component={VendorsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="personnel" path="/personnel/home" component={PersonnelPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="vendors" path="/accounts-payable/vendors" component={VendorsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate exact={true} key="vendors" path="/accounts-payable/vendors" component={VendorsPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="vouchers" path="/accounts-payable/vouchers" component={VouchersPage} isLoggedIn={isLoggedIn} />,
        <RoutePrivate key="credit-card-reconciliation" path="/accounts-payable/credit-card-reconciliation" component={CreditCardsRecPage} isLoggedIn={isLoggedIn} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/accounts-payable/AP.Routes.tsx